import React, { useState } from "react";
import { X } from "lucide-react";
import { Sl, Inp, Bt, SearchSelect, MultiSelect } from "./index";

export const FormModal = ({ title, fields, onSubmit, onClose, initialValues }) => {
  const [vals, setVals] = useState(() => {
    const iv = initialValues || {};
    const out = {};
    for (const k in iv) { const v = iv[k]; out[k] = Array.isArray(v) ? v.map(String) : v == null ? "" : String(v); }
    return out;
  });
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const doSubmit = async () => {
    setSaving(true); setErr("");
    try { await onSubmit(vals); onClose(); }
    catch (e) { setErr(e.message || "Error"); }
    finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 animate-fadeIn bg-black/35 z-[200] flex items-center justify-center p-3" onMouseDown={onClose}>
      {/* onMouseDown (not onClick) closing here + stopPropagation on mousedown below —
          a click fires on this backdrop even for a text-drag-select that started inside
          the card and drifted past its edge before mouseup; keying off mousedown avoids
          that false dismiss. */}
      <div className="animate-modalIn bg-bg1 border border-b1 rounded-2xl p-4 sm:p-6 w-full max-w-[712px] max-h-[85vh] overflow-auto shadow-[0_20px_60px_rgba(0,0,0,0.15)]" onMouseDown={e => e.stopPropagation()}>
        <div className="flex justify-between mb-4">
          <span className="text-base font-extrabold text-t0">{title}</span>
          <button onClick={onClose} className="bg-transparent border-0 text-t3 cursor-pointer"><X size={18} /></button>
        </div>
        {fields.map(f => (
          <div key={f.key} className="mb-[10px]">
            <div className="text-[14px] text-t2 mb-[3px]">{f.label}</div>
            {f.type === "multi-select" ? <>
                <MultiSelect options={f.options} value={Array.isArray(vals[f.key]) ? vals[f.key] : []} onChange={v => setVals(prev => ({ ...prev, [f.key]: v }))} placeholder={f.placeholder || "Select…"} searchPlaceholder={f.searchPlaceholder || "Type to search…"} />
                <div className="flex gap-3 mt-1 text-[13px]">
                  <button type="button" className="bg-transparent border-0 p-0 text-p cursor-pointer hover:underline" onClick={() => setVals(prev => ({ ...prev, [f.key]: f.options.filter(o => o.v !== "").map(o => String(o.v)) }))}>Select all</button>
                  <button type="button" className="bg-transparent border-0 p-0 text-t3 cursor-pointer hover:underline" onClick={() => setVals(prev => ({ ...prev, [f.key]: [] }))}>Clear</button>
                </div>
              </>
            : f.type === "select"
              ? <Sl options={f.options} value={vals[f.key] || ""} onChange={v => setVals(prev => ({ ...prev, [f.key]: v }))} />
              : f.type === "search-select"
                ? <SearchSelect options={f.options} value={vals[f.key] || ""} onChange={v => setVals(prev => ({ ...prev, [f.key]: v }))} placeholder={f.placeholder || "Select…"} searchPlaceholder={f.searchPlaceholder || "Type to search…"} />
                : <Inp placeholder={f.placeholder || ""} value={vals[f.key] || ""} onChange={v => setVals(prev => ({ ...prev, [f.key]: v }))} type={f.type} />
            }
          </div>
        ))}
        {err && <div className="text-[14px] text-r mb-2">{err}</div>}
        <div className="flex gap-[6px] mt-3">
          <Bt full onClick={doSubmit} disabled={saving}>{saving ? "Saving..." : "Save"}</Bt>
          <Bt v="secondary" full onClick={onClose}>Cancel</Bt>
        </div>
      </div>
    </div>
  );
};
